var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map"},[_c('div',{ref:"map"}),(_vm.listMarkers)?_c('slider-country',{key:_vm.mapKey,attrs:{"countries":_vm.listMarkers}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }